import UserRoles from "@client.enums/userRoles";
import BaseModel from "./base";
import { get } from "lodash";

class UserModel extends BaseModel {
  constructor(user = {}, msg, issuer) {
    super(msg);

    this.issuer = issuer;
    this.id = get(user, "id", undefined);
    this.firstName = get(user, "firstName", "");
    this.lastName = get(user, "lastName", "");
    this.email = get(user, "email", "");
    this.role = get(user, "role", undefined);
    this.teams = get(user, "teams", []);
    this.salaryRangeId = get(user, "salaryRangeId", undefined);
    this.sendInvite = get(user, "sendInvite", true);
    this.validationRules = {
      firstName: {
        presence: { allowEmpty: false, message: msg.firstName },
      },
      lastName: {
        presence: { allowEmpty: false, message: msg.lastName },
      },
      email: {
        presence: { allowEmpty: false, message: msg.email },
        email: { message: msg.invalidEmail },
        domain: { value: this.issuer.email, message: msg.invalidDomain },
      },
      role: {
        presence: { allowEmpty: false, message: msg.role },
        inclusion: {
          within: [
            UserRoles.SuperAdmin,
            UserRoles.CXO,
            UserRoles.Executive,
            UserRoles.Manager,
            UserRoles.Viewer,
          ],
        },
      },
      salaryRangeId: {
        presence: { allowEmpty: false, message: msg.salaryRange },
        numericality: true,
      },
      teams: {
        teamRoleValidation: {
          message: msg.teams,
        },
      },
    };
  }
}

export default UserModel;
